import { v4 as uuidv4 } from 'uuid';

export const getUserSettings = () => {
    return JSON.parse(window.localStorage.getItem("user-settings") || '{}');
}

export const initNewSessionId = () => {
    const userSettings = getUserSettings();
    userSettings.sessionId = uuidv4();
    setItem('user-settings', JSON.stringify(userSettings));
}

export const getSessionId = () => {
    const userSettings = getUserSettings();
    return userSettings.sessionId;
}

export const setDarkMode = (bool: boolean) => {
    const userSettings = getUserSettings();
    userSettings.darkMode = bool;
    setItem('user-settings', JSON.stringify(userSettings));
}

export const saveResponseType = (int: number) => {
    const userSettings = getUserSettings();
    userSettings.responseType = int;
    setItem('user-settings', JSON.stringify(userSettings));

}

export const getResponseType = () => {
    const userSettings = getUserSettings();
    return userSettings.responseType || 1;
}

export const getDarkMode = () => {
    const userSettings = getUserSettings();
    if("darkMode" in userSettings) return userSettings.darkMode;
    return true;
}

export const setItem = (key: string, item: string) => {
    window.localStorage.setItem(key, item);
}